import {
  sentBlueprintRequest,
  fetchSendBlueprintRequestFailure,
  fetchgetTitleAndEscrowFailure,
  showSuccessToast,
  fetchDismissCardFailure,
  saveTitleAndEscrow,
  SubmitReqState,
} from "../TransactionDetailsPage/SideRight/TitleAndEscrow/actions/creators";

export const defaultState = {
  uuid: "",
  error: null,
  lastSubmitted: null,
  titleType: "",
  isDismiss: false,
  submitReqState: { isloading: false, isSucceed: false, isFailed: false, failureMsg: "" },
  toastState: {
    show: false,
    msg: "",
  },
};

export const tdpTitleAndEscrowReducer = (state = defaultState, payload) => {
  switch (payload.type) {
    case sentBlueprintRequest().type:
      return {
        ...state,
        error: null,
      };
    case fetchSendBlueprintRequestFailure().type:
      return {
        ...state,
        error: payload.error,
      };
    case showSuccessToast().type: {
      return {
        ...state,
        error: null,
        toastState: payload.data,
      };
    }
    case fetchgetTitleAndEscrowFailure().type:
      return {
        ...state,
        error: payload.error,
      };
    case fetchDismissCardFailure().type:
      return {
        ...state,
        error: payload.error,
      };

    case saveTitleAndEscrow().type:
      return {
        ...state,
        isDismiss: payload.data?.meta?.dismissed_blueprint_info_card,
        lastSubmitted: payload.data?.blueprint_title?.submitted_at || "",
        titleType: payload.data?.blueprint_title?.title_type || "",
        error: null,
      };
    case SubmitReqState().type:
      return {
        ...state,
        submitReqState: payload.data,
      };
    default:
      return state;
  }
};

export default tdpTitleAndEscrowReducer;
